<template>
    <div class="row h-100">
        <div class="col-12">
            <div class="card h-100">
                <div class="card-header bg-info text-light">
                    TPM Tiered Performance Measurement: Admin
                </div>
                <div class="card-body p-0">
                    <div ref="container" class="container-fluid p-0 m-0 h-100 box-sizing-reset"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import fromCDN from 'from-cdn'

export default {
  name: 'TPMAdmin',
  components: {},
  mounted: function () {
    const self = this

    // this will not wait for css to complete before resolving
    fromCDN([
      // css
      process.env.BASE_URL + 'dhtmlx/5.2.0/skins/web/dhtmlx.css',
      process.env.BASE_URL + 'dhtmlx/5.2.0/skins/skyblue/dhtmlx.css',
      process.env.BASE_URL + 'dhtmlx/5.2.0/skins/terrace/dhtmlx.css',
      process.env.BASE_URL + 'dhtmlx/5.2.0/dhtmlx.css',
      process.env.BASE_URL + 'css/common.css',

      // js (libs/utils)
      process.env.BASE_URL + 'dhtmlx/5.2.0/dhtmlx.js',
      process.env.BASE_URL + 'js/lib/emitter.js',
      process.env.BASE_URL + 'js/lib/papaparse.min.js',
      process.env.BASE_URL + 'js/utils/polyfills.js',
      process.env.BASE_URL + 'js/utils/peiutils.js',
      process.env.BASE_URL + 'js/utils/peiajax.js'
    ])
      .then(_ => fromCDN([ process.env.BASE_URL + 'js/utils/peidhtmlx.js' ])) // this is loaded after because it depends on dhtmlx objects and peiutils
      .then(_ => fromCDN([
        process.env.BASE_URL + 'js/structs/peiCellInterface.js',
        process.env.BASE_URL + 'js/structs/peiEmployeeStruct.js',
        process.env.BASE_URL + 'js/structs/peiLocationStruct.js',
        process.env.BASE_URL + 'js/structs/peiOrgtreeNodeStruct.js',
        process.env.BASE_URL + 'js/structs/peiServiceStruct.js',
        process.env.BASE_URL + 'js/structs/peiServiceCollectionStruct.js',
        process.env.BASE_URL + 'js/structs/peiProcessStruct.js',
        process.env.BASE_URL + 'js/structs/peiProcessCollectionStruct.js',
        process.env.BASE_URL + 'js/structs/peiTPMDefStruct.js',
        process.env.BASE_URL + 'js/structs/peiTPMDefCollectionStruct.js',
        process.env.BASE_URL + 'js/structs/peiTPMCriteriaStruct.js',
        process.env.BASE_URL + 'js/structs/peiTPMCriteriaCollectionStruct.js',
        process.env.BASE_URL + 'js/structs/peiTPMCriteriaScoringTierStruct.js',
        process.env.BASE_URL + 'js/structs/peiTPMCriteriaScoringCollectionStruct.js',
        process.env.BASE_URL + 'js/addins/winAddin.js',
        process.env.BASE_URL + 'js/cells/fileuploaderCell.js',
        process.env.BASE_URL + 'js/cells/adminSidebarCell.js',
        process.env.BASE_URL + 'js/cells/adminEmpgridCell.js',
        process.env.BASE_URL + 'js/cells/adminSvcgridCell.js',
        process.env.BASE_URL + 'js/cells/adminLocgridCell.js',
        process.env.BASE_URL + 'js/cells/adminOrgtreeCell.js',
        process.env.BASE_URL + 'js/cells/adminTPMCriteriaCell.js',
        process.env.BASE_URL + 'js/cells/adminTPMCriteriaPropertiesCell.js',
        process.env.BASE_URL + 'js/cells/adminTPMCriteriaScoringCell.js',
        process.env.BASE_URL + 'js/cells/adminTPMCriteriaProcessesCell.js',
        process.env.BASE_URL + 'js/cells/adminFileuploadCell.js',
        process.env.BASE_URL + 'js/cells/adminTPMScoringCell.js',
        process.env.BASE_URL + 'js/cells/adminTPMSecurityCell.js',
        process.env.BASE_URL + 'js/tpmAdmin.js'
      ]))
      .then(_ => {
        /* globals _tpmAdmin */
        var tpmadmin = new _tpmAdmin(self.$refs.container, process.env.BASE_URL)
        tpmadmin.init()
      })
  }
}

</script>
<style>
    .box-sizing-reset * {
        box-sizing: content-box;
    }

    .peiSidebarItem {
        padding: 8px 0px;
    }
    .peiSidebarItem .sidebar_icon {
        float:left;
        font-size: 16px;
        line-height: 36px;
        width: 25px;
        text-align: center;
        margin-right: 8px;
    }
    .peiSidebarItem .sidebar_text {
        line-height: 36px;
    }

    .dhx_toolbar_material.dhxtoolbar_icons_18 div.dhx_toolbar_btn i.fa {
        font-size: 12px;
    }

    .dhxform_base legend {
        width: auto;
    }

    .dhxsidebar_item.dhxsidebar_item_selected .sidebar_icon.fa {
        color:#85d3ff;
    }

    /* from new-branch-checklist */
    .dhx_list .dhx_list_item {
        width:auto !important;
    }

    .dhx_list .dhx_list_default_item,
    .dhx_list .dhx_list_default_item_selected {
        position: relative;
    }

    .dhx_list .listitem_section_header {
        font-size: 16px;
    }
    .dhx_list .listitem_section_body {
        line-height: 16px;
    }

    .dhx_list .listitem_checkbox_content {
        width: 100%;
        padding-right: 75px;
    }

    .dhx_list .listitem_section_actions {
        position: absolute;
        bottom: 10px; /* standard padding */
    }

    .dhx_list_item[data-listitem_color="red"] {
        background-color: #ff8a80; /* @see: https://materializecss.com/color.html; red accent-1 */
    }
    .dhx_list_item.dhx_list_default_item_selected[data-listitem_color="red"] {
        background-color: #ff8a80; /* @see: https://materializecss.com/color.html; red accent-1 */
        border-left: 2px solid #f44336; /* @see: https://materializecss.com/color.html; red */
    }

    .dhx_list_item[data-listitem_color="blue"] {
        background-color: #82b1ff; /* @see: https://materializecss.com/color.html; blue accent-1 */
    }
    .dhx_list_item.dhx_list_default_item_selected[data-listitem_color="blue"] {
        background-color: #82b1ff; /* @see: https://materializecss.com/color.html; blue accent-1 */
        border-left: 2px solid #2196f3; /* @see: https://materializecss.com/color.html; blue */
    }

    .dhx_list_item[data-listitem_color="green"] {
        background-color: #b9f6ca; /* @see: https://materializecss.com/color.html; green accent-1 */
    }
    .dhx_list_item.dhx_list_default_item_selected[data-listitem_color="green"] {
        background-color: #b9f6ca; /* @see: https://materializecss.com/color.html; green accent-1 */
        border-left: 2px solid #4caf50; /* @see: https://materializecss.com/color.html; green */
    }

    .dhx_list_item span.badge {
        padding: 2px 4px;
        font-size: 10px;
        color: #fff;
        vertical-align: top;
    }

    .listitem_seq {

    }

    .listitem_title {

    }

    .listitem_checkbox {
        position: absolute;
        right: 10px;
        top: 10px;
    }

    .listitem_smalltext {
        font-size: 12px;
        line-height: 16px;
    }
    .listitem_value {
        color: #6d6d6d;
    }
    .dhx_list_default_item_selected .listitem_value {
        color: #6d6d6d;
    }

    br.listitem_spacer {
        display: block;
        margin: 0px;
        content: " ";
        line-height: 0px;
    }
    br.listitem_row {
        line-height: 18px;
    }

    #checklist-container a:hover {
        color: #1876d2;
    }

    #checklist-container a {
        color: #03a9f4;
        outline: none;
        cursor: pointer;
        text-decoration: none;
    }

    .listitem_progress {
        background-color:#cacece;
    }

    .dhx_list div.dhx_list_default_item_selected .listitem_progress {
        background-color:#fcfefe;
    }

    span.listitem_alerttext {
        color: #ff5d5d;
    }

    .dhx_list .listitem_only_selected {
        display: none;
    }
    .dhx_list .dhx_list_default_item_selected .listitem_only_selected {
        display: block;
    }

    /** materializecss overrides */
    .dhxform_base input:not([type]),
    .dhxform_base input[type=text],
    .dhxform_base input[type=password],
    .dhxform_base input[type=email],
    .dhxform_base input[type=url],
    .dhxform_base input[type=time],
    .dhxform_base input[type=date],
    .dhxform_base input[type=datetime],
    .dhxform_base input[type=datetime-local],
    .dhxform_base input[type=tel],
    .dhxform_base input[type=number],
    .dhxform_base input[type=search],
    .dhxform_base textarea.materialize-textarea {
        height: auto;
    }

    .dhxform_label label {
        color: inherit;
        font-size: inherit;
    }
</style>
